import React, { FC } from 'react'
import { Badge, Box, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import FilesButton from '@/app/[locale]/(public)/propiedades/[slug]/_components/FilesButton'
import { SpaceDTO } from '@/core/space/typings'

interface SpaceItemProps {
  space: SpaceDTO
}

const SpaceItem: FC<SpaceItemProps> = ({ space }) => {
  return (
    <VStack p={6} spacing={8} w="full" bg="background.surface" rounded="md">
      <Heading w="full" as="h3" fontSize="2xl" fontWeight="bold">
        {space.additionalData.floor} - {space.name}
      </Heading>

      <HStack w="full">
        <Text flex={1} fontSize="sm" color="blackAlpha.700" fontWeight="bold">
          {space.size}
        </Text>

        <HStack>
          <Badge
            w={'60px'}
            textAlign="center"
            rounded="full"
            p={1}
            fontSize="xs"
            color="text.invert"
            bg={'primary'}>
            <Text>{space.additionalData.contractType}</Text>
          </Badge>
          <Text flex={1} fontSize="sm" color="blackAlpha.700" fontWeight="bold">
            {space.price}
          </Text>
        </HStack>
      </HStack>

      <HStack alignSelf="flex-start" w={{ base: 'full', md: '50%' }}>
        <VStack align="flex-start" flex={1}>
          <Text flex={1} fontSize="sm" color="blackAlpha.700">
            Status
          </Text>
          <Text flex={1} fontSize="md" fontWeight="bold" color="primary">
            {space.available ? 'Disponible' : 'No disponible'}
          </Text>
        </VStack>
      </HStack>
      <Box w="full">
        <FilesButton
          bg="gray.100"
          label="Planos y brochures"
          description="Descarga información acerca del espacio"
          medias={space.medias}
        />
      </Box>
    </VStack>
  )
}

export default SpaceItem
